import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "premium-adjust-modal" }
const _hoisted_2 = { class: "premium-adjust-modal__head" }
const _hoisted_3 = { class: "premium-adjust-modal__body" }
const _hoisted_4 = { class: "premium-adjust-modal__table-wrap" }
const _hoisted_5 = { class: "premium-adjust-modal__table" }
const _hoisted_6 = { class: "premium-adjust-modal__kind" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "right premium-adjust-modal__auto" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = ["value", "onInput", "onBlur"]
const _hoisted_11 = {
  key: 0,
  class: "premium-adjust-modal__return"
}
const _hoisted_12 = { class: "premium-adjust-modal__return-label" }
const _hoisted_13 = { class: "premium-adjust-modal__return-value" }
const _hoisted_14 = { class: "premium-adjust-modal__holiday-action" }
const _hoisted_15 = { class: "premium-adjust-modal__footer" }

import { computed, reactive, watch } from 'vue';
import { formatWageNumber, parseWageNumber } from '@/composables/wage/useWageCalculator';
import { formatHomeWagePremiumHoursDisplay } from '@/policies';

export type PremiumAdjustKey = 'overtime' | 'night' | 'holiday';

export interface PremiumAdjustRowDef {
  key: PremiumAdjustKey;
  label: string;
  hours: number;
  autoAmount: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWagePremiumAdjustModal',
  props: {
    modelValue: { type: Boolean },
    isFamilyCare: { type: Boolean },
    autoAllocatedTotal: {},
    rows: {},
    initialManual: {}
  },
  emits: ["update:modelValue", "apply", "cancel", "show-holiday-detail"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localAmounts = reactive<Record<PremiumAdjustKey, number>>({
  overtime: 0,
  night: 0,
  holiday: 0,
});

const localDisplay = reactive<Record<PremiumAdjustKey, string>>({
  overtime: '',
  night: '',
  holiday: '',
});

const syncFromProps = () => {
  for (const key of ['overtime', 'night', 'holiday'] as PremiumAdjustKey[]) {
    const val = Math.max(0, Number(props.initialManual[key]) || 0);
    localAmounts[key] = val;
    localDisplay[key] = val > 0 ? formatWageNumber(val) : '';
  }
};

watch(
  () => props.modelValue,
  (open) => {
    if (open) syncFromProps();
  }
);

watch(
  () => props.initialManual,
  () => {
    if (props.modelValue) syncFromProps();
  },
  { deep: true }
);

const formatMoney = (n: number) => formatWageNumber(Math.max(0, Math.round(n)));

const displayRows = computed(() =>
  props.rows.map((row) => ({
    ...row,
    hoursLabel: formatHomeWagePremiumHoursDisplay(row.hours)
      ? `${formatHomeWagePremiumHoursDisplay(row.hours)}h`
      : '-',
  }))
);

const manualTotal = computed(() =>
  localAmounts.overtime + localAmounts.night + localAmounts.holiday
);

const returnPreview = computed(() =>
  Math.max(0, props.autoAllocatedTotal - manualTotal.value)
);

const onMoneyInput = (key: PremiumAdjustKey, event: Event) => {
  const target = event.target as HTMLInputElement;
  const cleaned = target.value.replace(/[^\d]/g, '');
  localDisplay[key] = cleaned;
  localAmounts[key] = parseWageNumber(cleaned);
};

const onMoneyBlur = (key: PremiumAdjustKey) => {
  const val = Math.max(0, localAmounts[key] || 0);
  localAmounts[key] = val;
  localDisplay[key] = val > 0 ? formatWageNumber(val) : '';
};

const onApply = () => {
  emit('apply', {
    overtime: Math.max(0, localAmounts.overtime),
    night: Math.max(0, localAmounts.night),
    holiday: Math.max(0, localAmounts.holiday),
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "520",
    persistent: "",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "premium-adjust-modal__title" }, "연장야간휴일 설정", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "premium-adjust-modal__close",
            "aria-label": "닫기",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "구분"),
                  _createElementVNode("th", { class: "right" }, "시간"),
                  _createElementVNode("th", { class: "right" }, "지급가능액"),
                  _createElementVNode("th", { class: "right" }, "지급할금액")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayRows.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.key
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(row.label), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(row.hoursLabel), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(formatMoney(row.autoAmount)), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("input", {
                        type: "text",
                        class: "premium-adjust-modal__input",
                        inputmode: "numeric",
                        value: localDisplay[row.key],
                        onInput: ($event: any) => (onMoneyInput(row.key, $event)),
                        onBlur: ($event: any) => (onMoneyBlur(row.key))
                      }, null, 40, _hoisted_10)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          (returnPreview.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(__props.isFamilyCare ? '기본급' : '연차수당') + " 환원 예상 ", 1),
                _createElementVNode("span", _hoisted_13, _toDisplayString(formatMoney(returnPreview.value)) + "원", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_btn, {
              variant: "flat",
              class: "btn-edit",
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('show-holiday-detail')))
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" 휴일수당 근무 내역 ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("footer", _hoisted_15, [
          _createVNode(_component_v_btn, {
            variant: "text",
            class: "btn-cancel",
            size: "small",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("취소", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            variant: "flat",
            class: "btn-confirm",
            size: "small",
            onClick: onApply
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("적용", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})